import UploadedBalanceTransferReportList from './UploadedBalanceTransferReportList';
import { CustomPageHeader, Text, useText } from '@src/components';

const BalanceTransferReport = () => {
  const companyInformation2 = useText('companyInformation2');
  return (
    <CustomPageHeader
      data-testid="uploaded-balance-report"
      title={<Text t="balanceTransferReport" />}
      showBreadCrumb
      showHelpButton
      routes={[companyInformation2]}
    >
      <UploadedBalanceTransferReportList />
    </CustomPageHeader>
  );
};

export default BalanceTransferReport;
